// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import "bootstrap"
import "@fortawesome/fontawesome-free/js/all.js"
import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import "stylesheets/application"
import "../../frontend/components"
import "../cookieConsent"
import "controllers"
import "chartjs-adapter-moment"
import moment from "moment"
import "moment/locale/fr"
import "pwa"

moment.locale("fr-FR")
Rails.start()
Turbolinks.start()
ActiveStorage.start()
